import axios,{ AxiosError,AxiosResponse } from "axios";
import { AuthBodyType } from "../types";
import { applyFirebaseTokenRetry } from './api';
class Teams {
  private api = applyFirebaseTokenRetry(axios.create({
    baseURL: `${process.env.REACT_APP_API_HOST}/equipes`,
  }));

  getAllByCurrentUser = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await this.api.post("/getAllByCurrentUser", {
        ...body,
      });
      return data.data.teams;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getBasicUsersInfoByTeam = async (body: AuthBodyType, team: string) => {
    try {
      const data: AxiosResponse = await this.api.post("/getBasicUsersInfoByTeam", {
        ...body,
        team,
      });
      return data.data.usersInfo;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  addTypeOnTeam = async (
    body: AuthBodyType & {
      typeId: string;
      equipeId: string[];
    },
  ) => {
    try {
      const data: AxiosResponse = await this.api.post("/addType", {
        ...body,
      });
      return data.data.usersInfo;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getTeamById = async (body: AuthBodyType & { equipeId: string }) => {
    try {
      const data: AxiosResponse = await this.api.post("/getTeamById", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  updateTeam = async (
    body: AuthBodyType,
    equipeId: string,
    equipe: {
      listaCliente?: string[];
      nome?: string;
      status?: boolean;
      tiposServico?: string[];
      users?: string[];
    },
  ) => {
    try {
      const data: AxiosResponse = await this.api.post("/changeTeam", {
        ...body,
        equipeId,
        equipe,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  createTeam = async (body: AuthBodyType, teamName: string, users: string[], tiposServico?: string[]) => {
    try {
      const data: AxiosResponse = await this.api.post("/newTeam", {
        ...body,
        teamName,
        users,
        tiposServico,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getSimpleTeams = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await this.api.post("/getSimpleTeams", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };
}

export default Teams;
